
import { ActionTree } from 'vuex';
import { Observable, Subscriber, forkJoin, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import * as _ from 'lodash';

import { PKState } from './state';
import { FudapiService } from '../utils/fudapi.service';
import Util from '../utils/util';
import { PKConfig } from '../config';
const pkConfig: PKConfig = require('../config.json');
import * as moment from "moment";


function fetchDocuments(store, idArr, startLoad: StartLoad | undefined, cb) {
  startLoad = startLoad ? startLoad : undefined;
  if (!idArr || idArr.length < 1) {
    return;
  }
  const newIds: any[] = [];
  const out: any[] = [];
  idArr.forEach(id => {
    const s = store.state.documents.find(a => a._id === id);
    if (s) {
      // from cache
      console.log('from cache', id);
      out.push(s);
    } else {
      newIds.push(id);
    }
  });

  if (newIds.length > 0) {
    const disposable = FudapiService.getDocumentData(newIds).subscribe((res) => {
      if (!res || !res.doc) {
        return;
      }
      res.doc.forEach(doc => {
        out.push(doc);
        store.commit('addDocument', doc);
      });
      if (cb) {
        cb(out, startLoad);
      }
    });
    if (startLoad) {
      startLoad.threads.push(<Subscriber<any>>disposable);
    }
  } else {
    cb(out, startLoad);
  }
}

function fetchSlideset(store, idArr, startLoad: StartLoad | undefined, cb) {
  fetchDocuments(store, idArr, startLoad, (docArr) => {
    if (!docArr || docArr.length < 1) {
      return;
    }
    const out: any[] = [];
    docArr.forEach(doc => {
      const publish = doc._source['54_sspublish'];
      if (publish !== 'yes' && doc._source['54_sstypeset'] !== 'nominal version') {
        return;
      }
      const obj = getSlidesetObj(store, startLoad);
      obj.doc = doc;
      obj._id = doc._id;

      // how to show set title
      const article = obj.doc._source['54_sswordarticle'];
      const combTitle = article ? article + ' ' + obj.doc._source['54_ssmaintitle'] : obj.doc._source['54_ssmaintitle'];
      const toShowTitle = [
        combTitle,
        obj.doc._source['54_sssigle'] ? 'Identifier: ' + obj.doc._source['54_sssigle'] : ''
      ].join(', ').trim().replace(/,$/, '');
      obj.combTitle = combTitle;
      obj.toShowTitle = toShowTitle;

      // how to show metadata
      obj._getYear = (str: string) => {
        if (!str || str === '0000-00-00') {
          return '';
        }
        return str.split('-')[0];
      };
      obj.getToShowMetadata = () => {
        const s = obj.doc._source;
        let mf = '';
        const manufacturer = obj.$_manufacturer;
        if (manufacturer && manufacturer[0]) {
          mf = obj.$_manufacturer[0]._source;
          mf = [mf['55_wordarticle'], mf['55_mainpartname']].join(' ');
        }

        let dateOfManuf = obj._getYear(s['54_ssearlposs']) ? obj._getYear(s['54_ssearlposs'])
          : obj._getYear(s['54_ssfirstdate']);
        dateOfManuf = s['54_ssfirdtcmt'] ? s['54_ssfirdtcmt'] + ' ' + dateOfManuf
          : dateOfManuf;

        const meta: any[] = [];
        meta.push({
          key: 'Manufacturer',
          text: mf
        });
        meta.push({
          key: 'Country of origin',
          text: s['54_sscountrylist']
        });
        meta.push({
          key: 'Date of manufacture',
          text: dateOfManuf
        });
        meta.push({
          key: 'Number of slides',
          text: s['54_ssadjmininum'] ? s['54_ssadjmininum'] + ' ' + s['54_ssniminalnumber'] : s['54_ssniminalnumber']
        });
        meta.push({
          key: 'Surviving number of slides',
          text: s['54_sstypeset'] === 'surviving version' ? obj.slides.length + '' : ''
        });
        meta.push({
          key: 'Main type of image',
          text: s['54_ssimgtypelist']
        });
        meta.push({
          key: 'Main usage of set',
          text: s['54_ssusagelist']
        });
        meta.push({
          key: 'Packaging',
          text: s['54_sspackaging']
        });
        meta.push({
          key: 'Editor',
          text: s['54_ssfudeditor']
        });
        return meta;
      };

      out.push(obj);
    });
    if (cb) {
      cb(out);
    }
  });
}

function getSlidesetObj(store, startLoad: StartLoad | undefined) {
  const t: any = {};
  t.showInMatrix = true;
  t.__ = {
    slides: null,
    slidesPerform: null,
    texts: null,
    relatedItems: null,
    manufacturer: null,
    hasQueryLinkedDoc: false
  };
  Object.defineProperty(t, 'relatedItems', {
    get: () => {
      if (t.__.relatedItems == null) {
        t.__.relatedItems = [];
        queryRelatedItemsInSS();
      }
      return t.__.relatedItems;
    }
  });

  Object.defineProperty(t, 'slides', {
    get: () => {
      if (!t.__.hasQueryLinkedDoc) {
        queryLinkedDoc(startLoad);
        t.__.hasQueryLinkedDoc = true;
      }
      return t.__.slides;
    }
  });

  Object.defineProperty(t, 'slidesPerform', {
    get: () => {
      // inited by property 'slides'
      return t.__.slidesPerform;
    }
  });

  Object.defineProperty(t, 'texts', {
    get: () => {
      if (!t.__.hasQueryLinkedDoc) {
        queryLinkedDoc(startLoad);
        t.__.hasQueryLinkedDoc = true;
      }
      return t.__.texts;
    }
  });

  Object.defineProperty(t, '$_manufacturer', {
    get: () => {
      if (t.__.manufacturer == null) {
        t.__.manufacturer = [];
        const omArr = t.doc._source['54_Organisations_Manufacturer'];
        if (omArr) {
          const omids: any[] = [];
          omArr.forEach(om => {
            omids.push(om['ssmasorgani']);
          });
          fetchDocuments(store, omids, startLoad, (docArr) => {
            docArr.forEach(d => {
              t.__.manufacturer.push(d);
            });
          });
        }

      }
      return t.__.manufacturer;
    }
  });

  const queryRelatedItemsInSS = () => {
    const riItems = t.doc._source['54_Related_items'];
    if (riItems) {
      const riIds: any[] = [];
      // sort
      riItems.sort((a, b) => {
        return parseInt(a['ssmasreitorder'], 10) - parseInt(b['ssmasreitorder'], 10);
      });
      riItems.forEach(ri => {
        riIds.push(ri['ssmasreit']);
      });
      // console.log(riItems);
      FudapiService.getDocumentData(riIds).subscribe((riDocs) => {
        const tempArray: any = [];
        riDocs.doc.forEach((ri, i) => {
          ri.$_images = [];
          const unlimited = ri._source['139_Image_as_attachments_unlimited'];
          if (unlimited) {
            unlimited.forEach((a, j) => {
              const o = a.rimasimun;
              const key = 'idx-' + i + '-' + j;
              const fName = o.filename;
              const tmp: ImageUnlimitedBlockInfo = {
                key: key,
                filename: fName,
                sourcename: o.sourcename,
                dbImageInfo: {
                  sourcename: o.sourcename,
                  name: fName,
                  timestamp: 0,
                  tag: '',
                  originalUrl: '',
                  small: '',
                  thumbnail: ''
                }
              };
              ri.$_images.push(tmp);
              if (fName) {
                setupImageLinks(tmp);
              }
            });
          }
          tempArray[riIds.indexOf(ri._id)] = ri;
        });
        tempArray.forEach(item => t.__.relatedItems.push(item));
      });
    }
  };

  const queryRelatedItemsInSlide = (sl) => {
    sl.relatedItems = [];
    const riItems = sl._source['56_Related_items'];
    if (riItems) {
      const riIds: any[] = [];
      // sort
      riItems.sort((a, b) => {
        return parseInt(a['slmasreitorder'], 10) - parseInt(b['slmasreitorder'], 10);
      });
      riItems.forEach(ri => {
        riIds.push(ri['slmasreit']);
      });

      FudapiService.getDocumentData(riIds).subscribe((riDocs) => {
        riDocs.doc.forEach((ri, i) => {
          ri.$_images = [];
          const unlimited = ri._source['139_Image_as_attachments_unlimited'];
          if (unlimited) {
            unlimited.forEach((a, j) => {
              const o = a.rimasimun;
              const key = 'idx-' + i + '-' + j;
              const fName = o.filename;
              const tmp: ImageUnlimitedBlockInfo = {
                key: key,
                filename: fName,
                sourcename: o.sourcename,
                dbImageInfo: {
                  sourcename: o.sourcename,
                  name: fName,
                  timestamp: 0,
                  tag: '',
                  originalUrl: '',
                  small: '',
                  thumbnail: ''
                }
              };
              ri.$_images.push(tmp);
              if (fName) {
                setupImageLinks(tmp);
              }
            });
          }
          sl.relatedItems.push(ri);
        });
      });
    }
  };

  const queryVideosInSlide = (sl) => {
    sl.videos = [];
    const obsList: any = [];
    const tmpVideoInfoList: any = [];
    for (let i = 0; i < 10; i++) {
      // let obs = Observable.of({});
      const fileName = sl._source['56_sourcename' + i];
      if (fileName && /\.(webm|mp4)$/.test(fileName)) {
        let order = 0;
        if (sl._source['56_slatts' + i + 'order']) {
          order = parseInt(sl._source['56_slatts' + i + 'order'], 10);
        }
        const videoInfo = {
          filename: fileName,
          originalName: '',
          order: order,
          src: '',
          type: '',
          fileInfo: ''
        };
        obsList.push(
          FudapiService.getFileURL(fileName).pipe(
            mergeMap((res: any) => {
              let type = 'video/mp4';
              const reg = /\.(.+)$/.exec(fileName);
              if (reg && reg[1]) {
                type = 'video/' + reg[1];
              }
              videoInfo.src = FudapiService.url + 'attachment/download/' + res.tag;
              videoInfo.type = type;
              videoInfo.fileInfo = res.fileInfo;
              return FudapiService.getFileOriginalName(fileName);
            }),
            mergeMap((res: any) => {
              if (res.data && res.data.length > 0) {
                if (res.data[0].doc_pic) {
                  videoInfo.originalName = res.data[0].doc_pic;
                } else {
                  videoInfo.originalName = res.data[0].doc_anhang;
                }
              }
              tmpVideoInfoList.push(videoInfo);
              return of({});
            }),
          )
        );
      }
    }
    forkJoin(...obsList).subscribe(
      undefined,
      err => console.log(err),
      () => {
        tmpVideoInfoList.sort((a, b) => a.order - b.order);
        sl.videos = tmpVideoInfoList;
      }
    );

    sl.activeVideoKey = 0;
    sl.getActiveVideo = () => {
      if (sl.videos.length <= 0) {
        return;
      }
      return sl.videos[sl.activeVideoKey];
    };
  };

  const queryAnimationInSlide = (sl) => {
    sl.animations = [];
    // for test
    const animationDefinitions = sl._source['56_Animation_definitions'];
    const ims = sl._source['56_Images_as_attachment_unlimited'];
    if (animationDefinitions && animationDefinitions.length > 0 && ims && ims.length > 0) {
      for (const ad of animationDefinitions) {
        let tileImageName = ad.slmasanideftilemap;
        const tileImageW = parseInt(ad.slmasanideftilew, 10);
        const tileImageH = parseInt(ad.slmasanideftileh, 10);
        let overviewImageName = ad.slmasanidefovi;
        const useEffectColor = ad.slmasanidefuseec === '1' ? true : false;
        let effectConfig = '';
        let configError = '';
        try {
          effectConfig = JSON.parse(ad.slmasanidefeffcon);
        } catch (e) {
          configError = e.toString();
        }
        for (const im of ims) {
          if (im.slmasimun && im.slmasimun.filename) {
            if (im.slmasimun.sourcename === tileImageName) {
              tileImageName = im.slmasimun.filename;
            }
            if (im.slmasimun.sourcename === overviewImageName) {
              overviewImageName = im.slmasimun.filename;
            }
          }
        }
        const adObj = {
          name: ad.slmasanidefname,
          description: ad.slmasanidefdesc,
          order: ad.slmasanideforder ? parseInt(ad.slmasanideforder, 10) : 999999,
          image: '',
          imageOriginalName: '',
          pictures: {
            width: tileImageW,
            height: tileImageH,
            spacing: 0,
            margin: 0,
            regX: 0,
            regY: 0,
          },
          overview: {
            src: ''
          },
          showEffectColor: useEffectColor,
          steps: effectConfig,
          error: configError
        };
        sl.animations.push(adObj);

        // query image url
        FudapiService.getFileURL(tileImageName).pipe(
          mergeMap((res: any) => {
            if (res && res.tag) {
              adObj.image = FudapiService.url + 'attachment/download/' + res.tag;
              adObj.imageOriginalName = res.originalName;
            }
            if (overviewImageName) {
              return FudapiService.getFileURL(overviewImageName);
            } else {
              return of(undefined);
            }
          })
        ).subscribe(res => {
          if (res && res.tag) {
            adObj.overview.src = FudapiService.url + 'attachment/download/' + res.tag;
          }
        }, undefined, () => {
          // done
        });
      }
    }
    sl.animations.sort((a, b) => a.order - b.order);
    sl.activeAnimationKey = 0;
    sl.getActiveAnimation = () => {
      if (sl.animations.length <= 0) {
        return;
      }
      return sl.animations[sl.activeAnimationKey];
    };
    sl.getAnimationByOrder = (order: number) => {
      return sl.animations.find(a => a.order === order);
    };
  };

  const queryLinkedDoc = (startLoadSS: StartLoad | undefined) => {
    t.__.slides = [];
    t.__.slidesPerform = [];
    t.__.texts = [];
    fetchLinkedDoc(t._id, startLoadSS, (linkedData, startLoadRet) => {
      if (!linkedData) {
        return;
      }
      setSlides(linkedData, startLoadRet);
      setTexts(linkedData);
    });
  };

  const setTexts = (linkedData) => {
    linkedData.doc.forEach(d => {
      if (d._type !== 'doctyp61') {
        return;
      }
      const obj = d;
      obj._getYear = (str: string) => {
        if (!str || str === '0000-00-00') {
          return '';
        }
        return str.split('-')[0];
      };
      obj.getToShowMetadata = () => {
        const s = obj._source;
        const meta: any[] = [];
        let title = '';
        if (s['61_txwordarticle']) {
          title = s['61_txwordarticle'] + ' ';
        }
        if (s['61_txmaintitle']) {
          title += s['61_txmaintitle'] + ' ';
        }
        if (s['61_txsubtitle']) {
          title += s['61_txsubtitle'];
        }
        let textPeople = '';
        let musicPeople = '';
        if (s['57_People']) {
          for (const linkedPeople of s['57_People']) {
            if ((linkedPeople['txmaspsrela'].indexOf('author') > -1 ||
              linkedPeople['txmaspsrela'].indexOf('lyricist') > -1) && linkedPeople['name']) {
              textPeople += linkedPeople['name'] + '; ';
            }
            if (linkedPeople['txmaspsrela'].indexOf('composer') > -1 && linkedPeople['name']) {
              musicPeople += linkedPeople['name'] + '; ';
            }
          }
          textPeople.replace(/; $/, '');
          musicPeople.replace(/; $/, '');
        }
        meta.push({
          key: 'Type of text',
          text: s['61_txtptext']
        });
        meta.push({
          key: 'Title',
          text: title
        });
        meta.push({
          key: 'Text',
          text: textPeople
        });
        meta.push({
          key: 'Music',
          text: musicPeople
        });
        meta.push({
          key: 'Nation',
          text: s['61_txplpuna']
        });
        meta.push({
          key: 'Place',
          text: s['61_txplpupl']
        });
        meta.push({
          key: 'Date',
          text: s['61_txdatemancomm'] ? s['61_txdatemancomm'] + ' ' + obj._getYear(s['61_txdatemandate']) : obj._getYear(s['61_txdatemandate'])
        });
        meta.push({
          key: 'Format',
          text: s['61_txphypformat']
        });
        meta.push({
          key: 'No. of pages',
          text: s['61_txphydnop']
        });
        meta.push({
          key: 'Dimensions',
          text: 'tx dummy label'
        });
        meta.push({
          key: 'Length',
          text: s['61_txphypsw'] ? s['61_txphypsw'] + ' ' + s['61_txphypunits'] : ''
        });
        meta.push({
          key: 'Width',
          text: s['61_txphypsh'] ? s['61_txphypsh'] + ' ' + s['61_txphypunits'] : ''
        });
        return meta;
      };

      // get data about people linked with this text
      const idsOfTextPeople: any[] = [];
      const idsOfMusicPeople: any[] = [];
      let idsOfPeople: any[] = [];
      if (d._source['61_People']) {
        for (const linkedPeople of d._source['61_People']) {
          if (linkedPeople['txmaspsrela'].indexOf('author') > -1 ||
            linkedPeople['txmaspsrela'].indexOf('lyricist') > -1) {
            idsOfTextPeople.push(linkedPeople['txmasps']);
          }
          if (linkedPeople['txmaspsrela'].indexOf('composer') > -1) {
            idsOfMusicPeople.push(linkedPeople['txmasps']);
          }
        }
        idsOfPeople = _.union(idsOfTextPeople, idsOfMusicPeople);
      }
      if (idsOfPeople.length > 0) {
        FudapiService.getDocumentDataWithFilter(idsOfPeople, '57_pnamefirst,57_pnamefamily').subscribe(res => {
          if (res.doc && res.doc.length > 0) {
            for (const pd of res.doc) {
              let name = '';
              if (pd._source['57_pnamefirst']) {
                name = pd._source['57_pnamefirst'] + ' ';
              }
              if (pd._source['57_pnamefamily']) {
                name += pd._source['57_pnamefamily'];
              }
              name.replace(/ $/, '');
              name.replace(/^ /, '');
              for (const linkedPeople of d._source['61_People']) {
                if (linkedPeople['txmasps'] === pd._id) {
                  linkedPeople['name'] = name;
                  break;
                }
              }
            }
          }
        });
      }

      d.$_images = [];
      const sour = d._source;
      const unlimited = sour['61_Images_as_attachment_unlimited'];
      if (unlimited) {
        unlimited.forEach((a, i) => {
          const o = a.txmasimun;
          const key = 'idx' + i;
          const fName = o.filename;
          const tmp: ImageUnlimitedBlockInfo = {
            key: key,
            filename: fName,
            sourcename: o.sourcename,
            dbImageInfo: {
              sourcename: o.sourcename,
              name: fName,
              timestamp: 0,
              tag: '',
              originalUrl: '',
              small: '',
              thumbnail: ''
            }
          };

          d.$_images.push(tmp);
          if (fName) {
            setupImageLinks(tmp);
          }
        });
      }
      t.__.texts.push(d);
    });
  };

  const setSlides = (linkedData, startLoadRet: StartLoad | undefined) => {
    const min = t.doc._source['54_ssniminalnumber'];
    const max = t.doc._source['54_ssnimaxmalnumber'];
    let len = parseInt(min, 10);
    let lenPerform = 0;
    let slideCount = 0;

    // add slide     
    linkedData.doc.forEach(slide => {
      if (slide._type !== 'doctyp56') {
        return;
      }
      const source = slide._source;
      const setInfoList = source['56_Slide_Sets'];
      if (!setInfoList) {
        return;
      }
      let setInfo;
      // found setInfo according to setId
      for (const s of setInfoList) {
        if (s) {
          if (s['slmasssss'] === t.doc._id) {
            setInfo = s;
            if (!slide.$_positionPerformList) {
              slide.$_positionPerformList = [];
            }
            slide.$_positionPerformList.push(parseInt(setInfo['slmasssorder'], 10));
          }
        }
      }
      if (!setInfo) {
        return;
      }
      slideCount++;
      slide.$_position = parseInt(setInfo['slmasssslno'], 10);
      for (const pf of slide.$_positionPerformList) {
        if (lenPerform < pf) {
          lenPerform = pf;
        }
      }

      slide.$_images = [];
      slide.$_missing = false;
      slide.getActiveImage = () => {
        if (!slide.$_images || !slide.$_activeImageKey) {
          return;
        }
        return slide.$_images.find(a => a.key === slide.$_activeImageKey);
      };
      slide.getScreenImage = () => {
        return slide.$_images.find(a => {
          if (a.sourcename.indexOf('@screen1') > -1) {
            return a;
          } else if (a.sourcename.indexOf('@screen') > -1) {
            return a;
          }
        });
      };

      const unlimited = source['56_Images_as_attachment_unlimited'];
      if (unlimited) {
        unlimited.forEach((a, i) => {
          const o = a.slmasimun;
          const key = 'idx' + i;
          const fName = o.filename;
          const order = a.slmasimunorder ? parseInt(a.slmasimunorder, 10) : undefined;

          const tmp: ImageUnlimitedBlockInfo = {
            key: key,
            filename: fName,
            sourcename: o.sourcename,
            order,
            dbImageInfo: {
              sourcename: o.sourcename,
              name: fName,
              timestamp: 0,
              tag: '',
              originalUrl: '',
              small: '',
              thumbnail: ''
            }
          };
          if (o.sourcename.indexOf('@animation') < 0) {
            slide.$_images.push(tmp);
          }
        });

        // order imgs for thumbnail view
        slide.$_images.sort((a: ImageUnlimitedBlockInfo, b: ImageUnlimitedBlockInfo) => {
          if (a.order && b.order) {
            if (a.order > b.order) {
              return 1;
            } else {
              return -1;
            }
          } else if (b.order) {
            return 1;
          } else {
            return -1;
          }
        });

        const v = (<any>window).vueInstance;
        const thumbnailNum = parseInt(v.$route.query.thumbnail, 10);
        if (thumbnailNum && !isNaN(thumbnailNum) && v.$route.query.view !== 'ss-relateditems') {
          // thumbnail number contains no screen img
          const tempArray: ImageUnlimitedBlockInfo[] = [];
          for (const img of slide.$_images) {
            if (img.sourcename.indexOf('@screen') < 0) {
              tempArray.push(img);
            }
          }
          if (tempArray[thumbnailNum]) {
            slide.$_activeImageKey = tempArray[thumbnailNum].key;
          }
        } else {
          for (const img of slide.$_images) {
            if (img.sourcename.indexOf('@screen') < 0) {
              slide.$_activeImageKey = img.key; // first as default and not screen img
              break;
            }
          }
        }

        slide.$_images.forEach((a: ImageUnlimitedBlockInfo) => {
          if (a.filename) {
            setupImageLinks(a);
          }
        });

        let foundScreenImage = false;
        slide.$_images.forEach(a => {
          if (a.sourcename.includes('@front-trans.')) {
            slide.$_screenImage = a;
            foundScreenImage = true;
          }
        });
        if (!foundScreenImage) {
          slide.$_images.forEach(a => {
            if (a.sourcename.includes('@screen1.')) {
              slide.$_screenImage = a;
              foundScreenImage = true;
            }
          });
        }
        if (!foundScreenImage) {
          slide.$_images.forEach(a => {
            if (a.sourcename.includes('@screen.')) {
              slide.$_screenImage = a;
              foundScreenImage = true;
            }
          });
        }
        if (!foundScreenImage) {
          slide.$_images.forEach(a => {
            if (a.sourcename.includes('@per')) {
              slide.$_screenImage = a;
              foundScreenImage = true;
            }
          });
        }
        if (!foundScreenImage) {
          slide.$_images.forEach(a => {
            if (a.sourcename.includes('@front.')) {
              slide.$_screenImage = a;
              foundScreenImage = true;
            }
          });
        }
      }

      // fetch info about related items of this slide
      queryRelatedItemsInSlide(slide);

      // fetch info about videos
      queryVideosInSlide(slide);

      // fetch info about animations
      queryAnimationInSlide(slide);

      // how to show metadata of slide
      slide.getToShowMetadata = () => {
        const s = slide._source;
        const meta: any[] = [];
        meta.push({
          key: 'Dimensions',
          text: 'sl dummy label'
        });
        meta.push({
          key: 'Unit of Dimensions',
          text: s['56_sltdunitmeas']
        });
        meta.push({
          key: 'Length',
          text: s['56_sltdmeaartlen']
        });
        meta.push({
          key: 'Width',
          text: s['56_sltdmeaartwid']
        });
        meta.push({
          key: 'Depth',
          text: s['56_sltdmeaartdep']
        });
        meta.push({
          key: 'Diameter',
          text: s['56_sltdmeaartdim']
        });

        meta.push({
          key: 'Technical description',
          text: 'sl dummy label'
        });
        meta.push({
          key: 'Slide type',
          text: s['56_slsltyty']
        });
        meta.push({
          key: 'Movement mechanism',
          text: s['56_slsltymovmech']
        });
        meta.push({
          key: 'Image substrate',
          text: s['56_sltdimasubs']
        });
        meta.push({
          key: 'Type of image',
          text: s['56_slsltyimgty']
        });
        meta.push({
          key: 'Production process',
          text: s['56_slsltyprodproc']
        });
        meta.push({
          key: 'Slide colouring',
          text: s['56_sltdslcolr']
        });
        meta.push({
          key: 'Framing',
          text: s['56_sltdfram']
        });
        meta.push({
          key: 'Masking',
          text: s['56_sltdmask']
        });

        return meta;
      };

      t.__.slides.push(slide);
    });

    if (slideCount > len) {
      len = slideCount;
    }
    if (t.__.slides.length < len) {
      for (let i = 1; i <= len; i++) {
        const o = t.__.slides.find(a => {
          return a.$_position === i;
        });
        if (!o) {
          t.__.slides.push({
            $_position: i,
            $_positionPerformList: [],
            $_missing: true,
            $_images: [],
            getActiveImage: () => {
              return undefined;
            }
          });
        }
      }
    }
    // add slides to perform list
    if (lenPerform > 0) {
      for (let i = 1; i <= lenPerform; i++) {
        const o = t.__.slides.find(a => {
          return a.$_positionPerformList.indexOf(i) > -1;
        });
        if (!o) {
          // add lacking slides in matrix view
          t.__.slidesPerform[i - 1] = {
            $_position: i,
            $_positionPerformList: [i],
            $_missing: i <= len ? true : false,
            $_images: [],
            getActiveImage: () => {
              return undefined;
            }
          };
        } else {
          t.__.slidesPerform[i - 1] = o;
        }
      }
    }

    t.__.slides.sort((a, b) => {
      return a.$_position - b.$_position;
    });
    if (startLoadRet) {
      startLoadRet.deepestReached = true;
    }
  };

  return t;
}

function setupImageLinks(tmp: ImageUnlimitedBlockInfo) {
  const fName = tmp.filename;
  FudapiService.getFileURL(fName).subscribe((res) => {
    if (res.tag) {
      tmp.dbImageInfo.timestamp = res.fileInfo.timestamp;
      tmp.dbImageInfo.tag = res.tag;
      tmp.dbImageInfo.originalUrl = FudapiService.url + 'attachment/download/' + res.tag;
      tmp.dbImageInfo.thumbnail = tmp.dbImageInfo.originalUrl + '?small=200x200&unit=px';
      tmp.dbImageInfo.small = tmp.dbImageInfo.originalUrl + '?small=1024x1024&unit=px';
    }
  });
}

function fetchLinkedDoc(slidesetId, startLoad: StartLoad | undefined, cb) {
  const disposable = FudapiService.searchLinkedDocument(slidesetId).pipe(
    mergeMap((ids: any) => {
      let next = [];
      if (ids && ids.data && ids.data.length > 0) {
        next = ids.data;
      } else {
        cb(null, startLoad);
      }
      return FudapiService.getDocumentData(ids.data);
    }),
  ).subscribe((res) => {
    if (cb) {
      cb(res, startLoad);
    }
  });
  if (startLoad) {
    startLoad.threads.push(<Subscriber<any>>disposable);
  }
}

function fetchArchiveEdition(store, idArr, startLoad: StartLoad | undefined, cb) {
  fetchSlideset(store, idArr, startLoad, (docArr) => {
    docArr.forEach(doc => {
      // check if in critical editions
      doc.linkedCE = [];
      FudapiService.searchLinkedDocument(doc._id, 137).pipe(
        mergeMap((res: any) => {
          if (res.data && res.data.length > 0) {
            return FudapiService.getDocumentDataWithFilter(res.data, '137_cepublish');
          }
          return of({});
        }),
      ).subscribe((res: any) => {
        if (res.doc && res.doc.length > 0) {
          for (const d of res.doc) {
            if (d._source['137_cepublish'] === 'yes') {
              doc.linkedCE.push(d._id);
            }
          }
        }
      });
      store.commit('addArchiveEdition', doc);

    });
    if (cb) {
      cb(docArr);
    }
  });
}

const fetchCriticalEditionExternal = (store, idArr, startLoad: StartLoad | undefined, cb) => {
  startLoad = startLoad ? startLoad : undefined;
  fetchDocuments(store, idArr, startLoad, (docArr, startLoadRet: StartLoad | undefined) => {
    if (!docArr || docArr.length < 1) {
      return;
    }
    const out: any[] = [];
    docArr.forEach(doc => {
      if (doc && doc._source['137_cepublish'] === 'yes') {
        const obj = getCricticalEditionObj(store, startLoadRet);
        obj.doc = doc;
        obj._id = doc._id;
        store.commit('addCriticalEdition', obj);
        out.push(obj);
      }
    });
    // norminal version at first
    // out.sort((a, b) => {

    // });
    if (cb) {
      cb(out, startLoadRet);
    }
  });
};

const getCricticalEditionObj = (store, startLoad: StartLoad | undefined) => {
  const t: any = {};
  t.__ = {
    slidesets: null,
    comparisons: null
  };

  (<any>window).startLoad = startLoad;
  Object.defineProperty(t, 'slidesets', {
    get: () => {
      if (!t.__.slidesets) {
        t.__.slidesets = [];
        querySlidesets();
      }
      return t.__.slidesets;
    }
  });

  Object.defineProperty(t, 'comparisons', {
    get: () => {
      if (!t.__.comparisons) {
        // if(!t.__.hasQueryComparisons) {
        t.__.comparisons = [];
        queryComparisons();
        // t.__.hasQueryComparisons = true;
      }
      return t.__.comparisons;
    }
  });


  const queryComparisons = () => {
    const startLoadCE = (<any>window).startLoad;
    const cps = t.doc._source['137_Comparisons'];
    if (cps) {
      // t.__.comparisons = [];
      const cids: any[] = [];
      cps.forEach((c: any) => {
        cids.push(c['cemascomp']);
      });
      fetchDocuments(store, cids, startLoadCE, (docArr) => {
        docArr.forEach(d => {
          t.__.comparisons.push(d);
        });
        console.log('queryComparisons');
      });
    }
  };

  const querySlidesets = () => {
    console.log('critical Edition querySlidesets');
    const startLoadCE = (<any>window).startLoad;
    const ss = t.doc._source['137_Slide_sets'];
    if (ss) {
      // t.__.slidesets = [];
      const idArr: any[] = [];
      ss.forEach((c: any) => {
        idArr.push(c['cemasss']);
      });
      fetchSlideset(store, idArr, startLoadCE, (docArr) => {
        docArr.forEach(d => {
          t.__.slidesets.push(d);
        });
      });
    }
  };
  return t;
};

function fetchMonthSlideset(store, startLoad: StartLoad | undefined) {
  let comment = '';
  FudapiService.getDocumentData([130229]).pipe(
    mergeMap((ft: any) => {
      let ret;
      if (ft.doc && ft.doc[0] && ft.doc[0]._source['150_ftcontenttx']) {
        const contentStructure = ft.doc[0]._source['150_ftcontenttx'].split('<br>');
        const ssSigle = contentStructure[0];
        contentStructure.forEach((element, i) => {
          if (i > 0) {
            comment += element + '<br>';
          }
        });
        comment = comment.replace(/<br>$/, '');
        if (ssSigle) {
          ret = FudapiService.searchDocumentByFields(54, { sssigle: ssSigle }, 'and');
        }
      } else {
        ret = of(null);
      }
      return ret;
    }),
  ).subscribe((searchRes: any) => {
    if (searchRes && searchRes.data && searchRes.data[0]) {
      fetchArchiveEdition(store, [searchRes.data[0]], startLoad, (docArray) => {
        if (docArray && docArray[0]) {
          const obj = { str: comment };
          FudapiService.transformFreetext(obj).subscribe(() => {
            docArray[0].monthSlidesetComment = obj.str;
          });
          store.commit('monthSlideset', docArray[0]);
        }
      });
    }
  });
}

function fetchAllNews(store) {
  const news: string[] = [];
  const transText = {
    str: ''
  };
  FudapiService.getDocumentData([130230]).pipe(
    mergeMap((searchRes: any) => {
      if (searchRes && searchRes.doc && searchRes.doc[0]) {
        transText.str = searchRes.doc[0]._source['150_ftcontenttx'];
        return FudapiService.transformFreetext(transText);
      } else {
        return of(null);
      }
    }),
  ).subscribe(() => {
    const contentStructure = transText.str.split('<br>');
    const ssSigle = contentStructure[0];
    contentStructure.forEach((element, i) => {
      if (!/^\W*$/.test(element)) {
        news.push(element);
      }
    });
  });
  store.commit('allNews', news);
}

function fetchFrontText(store, startLoad: StartLoad | undefined) {
  FudapiService.getDocumentIdsByType(150).subscribe((res) => {
    if (res && res.docIds) {
      fetchDocuments(store, res.docIds, startLoad, (docArr) => {
        if (!docArr || docArr.length < 1) {
          return;
        }
        docArr.forEach(doc => {
          const sour = doc._source;
          if (sour) {
            const key = sour['150_ftfield'];
            if (key) {
              //  store.state.frontText[key] = sour['150_ftcontenttx'];
              store.commit('frontText', {
                key: key,
                text: sour['150_ftcontenttx']
              });
            }
          }
        });
      });
    }
  });
}

export const actions: ActionTree<PKState, PKState> = {

  fetchSearchResult(store, startLoad: StartLoad | undefined) {
    store.commit('resetSearchResult', null);
    const ids = ['130094', '130095', '130040'];
    fetchSlideset(store, ids, startLoad, (docArr) => {
      if (!docArr) {
        return;
      }
      docArr.forEach(doc => {
        store.commit('addSearchResult', doc);
      });
    });
  },

  fetchAllArchiveEditions(store, startLoad: StartLoad | undefined) {
    console.log('fetchAllArchiveEditions');
    FudapiService.searchDocumentByFields(54, {
      sspublish: 'yes'
    }, 'and').subscribe((res) => {
      if (!res || !res.data) {
        return;
      }
      const idArr = res.data;
      if (idArr.length > 0) {
        fetchArchiveEdition(store, idArr, startLoad, () => undefined);
      }
    });
  },

  fetchAllNominalVersion(store) {
    // TODO:
    FudapiService.searchDocumentByFields(54, {
      sstypeset: 'nominal version'
    }, 'and').subscribe((res) => {
      if (!res || !res.data) {
        return;
      }
      const idArr = res.data;
      console.log(idArr);
      if (idArr.length > 0) {
        // fetchArchiveEdition(store, idArr);
      }
    });
  },

  fetchTimelineData(store) {
    FudapiService.getTimelineData().subscribe(res=>{
      store.state.timelineData = res.timeline;
    })
    // FudapiService.searchDocumentByFields(58, {
    //   "tf_category": "%", "tf_casestudy": "%", "tf_eventtext": "%"
    // }, 'or').subscribe(res => {
    //   FudapiService.getDocumentData(res.data).subscribe(docRes => {
    //     console.log(docRes.doc)
    //     store.state.timelineData = docRes.doc;
    //   });
    // })
  },

  fetchSelectArchiveEdition(store, args: {
    startLoad: StartLoad | undefined,
    id: number,
    cb: (d: any) => void
  }) {
    const id = args.id;
    const startLoad = args.startLoad;
    const cb = args.cb;
    fetchArchiveEdition(store, [id], startLoad, (res) => {
      cb(res);
    });
  },

  fetchAllCriticalEditions(store, args: {
    startLoad: StartLoad | undefined
  }) {
    //  console.log('fetchAllCriticalEditions');
    const startLoad = args.startLoad;
    const disposable = FudapiService.getDocumentIdsByType(137).subscribe((res) => {
      const ids = res.docIds;
      const max = 200;
      let idArr: any[] = [];

      ids.forEach(id => {
        idArr.push(id);
        if (idArr.length >= max) {
          fetchCriticalEditionExternal(store, idArr, startLoad, undefined);
          idArr = [];
        }
      });
      if (idArr.length > 0) {
        fetchCriticalEditionExternal(store, idArr, startLoad, undefined);
      }
    });
    if (startLoad) {
      startLoad.threads.push(<Subscriber<any>>disposable);
    }
  },

  fetchCriticalEdition(store, args: { idArr, startLoad: StartLoad, cb }) {
    const idArr = args.idArr;
    const startLoad = args.startLoad;
    const cb = args.cb;
    fetchCriticalEditionExternal(store, idArr, startLoad, cb);
  },

  // fetchOneSlideset(store, args: {setId, startLoad: StartLoad, cb}) {
  //   const setId = args.setId;
  //   const startLoad = args.startLoad;
  //   const cb = args.cb;
  //   fetchCriticalEditionExternal(store, idArr, startLoad, cb);
  // },

  firstRun(store, startLoad: StartLoad | undefined) {
    fetchMonthSlideset(store, startLoad);
    fetchAllNews(store);
    fetchFrontText(store, startLoad);
  },

  fetchDeepZoomImageUrl(store, args: {
    dbImageInfo,
    cb,
    startLoad: StartLoad
  }) {
    const dbImageInfo = args.dbImageInfo;
    const startLoad = args.startLoad;
    const cb = args.cb;
    Util.checkStartLoad({
      loadingCount: 0,
      startLoad: startLoad,
      retryCondition: () => {
        return !dbImageInfo.originalUrl;
      },
      allDoneCallback: () => {
        startLoad.threads.push(<any>FudapiService.getDeepzoomURL(dbImageInfo.originalUrl, dbImageInfo.timestamp).subscribe((data) => {
          cb(data);
        }));
      }
    });
  },

  saveConfig(store, args: {
    fileName, data
  }) {
    let fileName = args.fileName;
    let data = args.data;
    fileName = fileName.trim();
    if (!fileName) {
      return;
    }
    fileName = fileName + '.json';


    data = JSON.stringify(data);
    const textFileAsBlob = new Blob([data], {
      type: 'text/json'
    });

    if ('msSaveOrOpenBlob' in navigator) {
      navigator.msSaveOrOpenBlob(textFileAsBlob, fileName);
    } else {
      const downloadLink = document.createElement('a');
      downloadLink.download = fileName;
      downloadLink.innerHTML = 'Download File';
      downloadLink.href = window.URL.createObjectURL(textFileAsBlob);
      downloadLink.onclick = function (e: any) {
        document.body.removeChild(e.target);
      };
      downloadLink.style.display = 'none';
      document.body.appendChild(downloadLink);
      downloadLink.click();
    }
  },



};

interface ImageUnlimitedBlockInfo {
  key: string;
  filename: string;
  sourcename: string;
  dbImageInfo: ImageShowInfo;
  order?: number;
}

interface ImageShowInfo {
  sourcename: string;
  name: string;
  tag: string;
  timestamp: number;
  originalUrl: string;
  small: string;
  thumbnail: string;
  inProgress?: boolean;
  deepzoom?: string;
}

export interface StartLoad {
  deepestReached: boolean;
  threads: Array<Subscriber<any>>;
}
